/**
 * Who a material was shared with, as seen by the shown member. Mirrors the backend
 * MaterialAudienceContract enum (PascalCase on the wire).
 */
export enum MaterialAudience {
  Everyone = "Everyone",
  Group = "Group",
  Member = "Member",
}
